import { object, string, array } from "yup";

export let schema = (t, mode) =>
  object({
    fullName: string()
      .required(t("validation:required-field"))
      .trim(),
    userName: (() => {
      let baseSchema = string().trim().required(t("validation:required-field"));
      return baseSchema;
    })(),
    email: string()
      .required(t("validation:required-field"))
      .matches(
        // /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/,
        t("validation:invalid-phone-number"),
      ),
    phoneNumber: string()
      .required(t("validation:required-field"))
      .transform((value) => (value ? value.replace(/[-\s]/g, "") : ""))
      .test(
        "hasExactDigits",
        t("validation:invalid-phone-number"),
        (value) => {
          if (!value) return false;
          return value.length === 10 && /^\d{10}$/.test(value);
        }
      )
      .trim(),
    doctorIds: array()
      .min(1, "Select At least one doctor" || "Select at least one doctor"),
    isActive: string().required(t("validation:required-field")),
  });
